/* ==========================================================================
   Mundo Dos Filtros — cookie-consent.js
   Aviso de cookies (LGPD): guarda a escolha e repassa para a API de
   consentimento da Shopify, que é quem realmente libera ou segura os pixels
   de análise e marketing. Sem essa segunda parte o banner seria só enfeite:
   os scripts continuariam rodando com ou sem o "aceitar".
   ========================================================================== */

(function () {
  'use strict';

  var CHAVE = 'mdf-cookies';

  /* Marca quando a visita começou. Fica separado do registro de consentimento
     porque precisa sobreviver à troca de página: o tempo até o aceite
     automático é de permanência no site, não em cada página. */
  var CHAVE_INICIO = 'mdf-cookies-inicio';

  /* Subir este número faz a loja perguntar de novo a todo mundo. É o que se
     usa quando as categorias mudam: um "aceito" dado para a lista antiga não
     cobre uma finalidade nova. */
  var VERSAO = 1;

  var CATEGORIAS = ['analise', 'marketing', 'preferencias'];

  var caixa = null;

  /* ----------------------------------------------------------- Registro -- */

  function ler() {
    try {
      var salvo = JSON.parse(window.localStorage.getItem(CHAVE));
      if (!salvo || salvo.versao !== VERSAO) return null;
      return salvo;
    } catch (erro) {
      return null;
    }
  }

  function salvar(escolha, origem) {
    var registro = {
      versao: VERSAO,
      /* A data fica junto porque a LGPD exige poder comprovar quando o
         consentimento foi dado (Art. 8º, §2º). */
      data: new Date().toISOString(),
      /* De onde veio o aceite: 'botao' quando a pessoa clicou no aviso,
         'tempo' ou 'navegacao' quando a loja decidiu por ela. Guardar isso
         separado é o mínimo de honestidade no registro — um aceite tácito
         não pode ser apresentado depois como se tivesse sido explícito. */
      origem: origem || 'botao',
      analise: !!escolha.analise,
      marketing: !!escolha.marketing,
      preferencias: !!escolha.preferencias
    };

    try {
      window.localStorage.setItem(CHAVE, JSON.stringify(registro));
    } catch (erro) {
      /* Navegação anônima com storage bloqueado: a escolha vale para esta
         visita e o aviso volta na próxima. Perguntar de novo é o lado certo
         para errar. */
    }

    aplicar(registro);
    return registro;
  }

  /* ------------------------------------------------------------ Shopify -- */

  /* A Shopify só expõe a API depois de carregar o recurso sob demanda. Sem
     esta chamada, setTrackingConsent não existe e a escolha não sai do tema. */
  function aplicar(escolha) {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (erro) {
        if (erro) return;

        var privacidade = window.Shopify.customerPrivacy;
        if (!privacidade || !privacidade.setTrackingConsent) return;

        privacidade.setTrackingConsent(
          {
            analytics: escolha.analise,
            marketing: escolha.marketing,
            preferences: escolha.preferencias,
            /* "Venda de dados" é de leis de fora, mas a Shopify usa a mesma
               chave para segurar parte dos pixels de anúncio, então ela
               acompanha a escolha de marketing. */
            sale_of_data: escolha.marketing
          },
          function () {}
        );
      }
    );
  }

  /* --------------------------------------------------------- Interface -- */

  function marcar(escolha) {
    CATEGORIAS.forEach(function (nome) {
      var campo = caixa.querySelector('[data-cookies-categoria="' + nome + '"]');
      if (campo) campo.checked = !!escolha[nome];
    });
  }

  function lerFormulario() {
    var escolha = {};
    CATEGORIAS.forEach(function (nome) {
      var campo = caixa.querySelector('[data-cookies-categoria="' + nome + '"]');
      escolha[nome] = !!(campo && campo.checked);
    });
    return escolha;
  }

  function mostrarCategorias(mostrar) {
    var painel = caixa.querySelector('[data-cookies-categorias]');
    var personalizar = caixa.querySelector('[data-cookies-personalizar]');
    var salvarBotao = caixa.querySelector('[data-cookies-salvar]');

    if (painel) painel.hidden = !mostrar;
    if (personalizar) personalizar.hidden = mostrar;
    if (salvarBotao) salvarBotao.hidden = !mostrar;
  }

  function abrir(comCategorias) {
    if (!caixa) return;

    marcar(ler() || {});
    mostrarCategorias(!!comCategorias);
    caixa.hidden = false;

    /* Levar o foco para dentro do aviso faz o leitor de tela anunciá-lo e dá
       ao teclado um ponto de partida; sem isso o aviso passa despercebido. */
    var alvo = caixa.querySelector('[data-cookies-aceitar]');
    if (alvo) alvo.focus();
  }

  function fechar() {
    if (caixa) caixa.hidden = true;
  }

  function decidir(escolha, origem) {
    salvar(escolha, origem);
    fechar();
  }

  function todas(valor) {
    var escolha = {};
    CATEGORIAS.forEach(function (nome) {
      escolha[nome] = valor;
    });
    return escolha;
  }

  /* ------------------------------------------------ Aceite automático -- */

  var relogio = null;
  var autoLigado = false;

  /* Momento em que a visita começou, em milissegundos. Guardado no
     localStorage para o relógio não reiniciar a cada página aberta. */
  function inicioDaVisita() {
    try {
      var salvo = parseInt(window.localStorage.getItem(CHAVE_INICIO), 10);
      if (salvo) return salvo;

      var agora = Date.now();
      window.localStorage.setItem(CHAVE_INICIO, String(agora));
      return agora;
    } catch (erro) {
      /* Sem storage o relógio vale só para esta página. */
      return Date.now();
    }
  }

  function limparInicio() {
    try {
      window.localStorage.removeItem(CHAVE_INICIO);
    } catch (erro) {}
  }

  function cancelarAuto() {
    autoLigado = false;
    if (relogio) {
      window.clearTimeout(relogio);
      relogio = null;
    }
  }

  function aceitarSozinho(origem) {
    if (!autoLigado || ler()) return;
    cancelarAuto();
    limparInicio();
    decidir(todas(true), origem);
  }

  function ligarAceiteAutomatico() {
    var segundos = parseInt(caixa.dataset.cookiesAutoSegundos, 10);
    var porInteracao = caixa.dataset.cookiesAutoInteracao === 'true';
    if (!segundos && !porInteracao) return;

    autoLigado = true;

    if (segundos) {
      /* Desconta o tempo já passado nas páginas anteriores. Se a pessoa
         voltar depois do prazo, o restante é zero e o aceite sai na hora. */
      var restante = segundos * 1000 - (Date.now() - inicioDaVisita());
      relogio = window.setTimeout(function () {
        aceitarSozinho('tempo');
      }, Math.max(0, restante));
    }

    if (porInteracao) {
      document.addEventListener(
        'click',
        function (evento) {
          /* Clique dentro do próprio aviso não conta: ali a pessoa está
             decidindo, e os botões já tratam a escolha real. */
          if (caixa.contains(evento.target)) return;
          if (!evento.target.closest('a[href], button, [role="button"]')) return;
          aceitarSozinho('navegacao');
        },
        /* Fase de captura para registrar a escolha antes de a navegação
           começar e a página ser descarregada. */
        true
      );
    }
  }

  /* ----------------------------------------------------------- Eventos -- */

  function iniciar() {
    caixa = document.querySelector('[data-cookies]');
    if (!caixa) return;

    var registro = ler();

    /* Já escolheu: nada aparece, mas a decisão precisa ser reaplicada a cada
       página, porque a API da Shopify não guarda estado entre carregamentos. */
    if (registro) {
      aplicar(registro);
      limparInicio();
    } else {
      abrir(false);
      ligarAceiteAutomatico();
    }

    caixa.addEventListener('click', function (evento) {
      if (evento.target.closest('[data-cookies-aceitar]')) return decidir(todas(true), 'botao');
      if (evento.target.closest('[data-cookies-rejeitar]')) return decidir(todas(false), 'botao');
      if (evento.target.closest('[data-cookies-salvar]')) return decidir(lerFormulario(), 'botao');

      if (evento.target.closest('[data-cookies-personalizar]')) {
        /* Abriu as opções: está escolhendo. Deixar o relógio correr por cima
           dessa escolha seria decidir no lugar de quem já se dispôs a decidir. */
        cancelarAuto();
        mostrarCategorias(true);
      }
    });

    /* Qualquer link ou botão com data-cookies-abrir reabre o aviso: é por onde
       a pessoa retira o consentimento depois, o que a LGPD garante a qualquer
       momento (Art. 8º, §5º). */
    document.addEventListener('click', function (evento) {
      var gatilho = evento.target.closest('[data-cookies-abrir]');
      if (!gatilho) return;
      evento.preventDefault();
      cancelarAuto();
      abrir(true);
    });
  }

  window.tema = window.tema || {};
  window.tema.cookies = { abrir: abrir, ler: ler };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
